import request from "@/utils/request";

export function getUserInfo() {
  return request({
    url: `/client/user/getInfo`,
    method: "get",
  });
}

export function updateUserInfo(data) {
  return request({
    url: `/client/user/editInfo`,
    method: "post",
    data,
  });
}


export function register(data) {
  return request({
    url: `/client/user/register`,
    method: "post",
    data,
  });
}
